import {
  INIT_MOBILE,
  INIT_EMAIL,
  VERIFY_MOBILE,
  VERIFY_EMAIL,
  RESEND_VERIFY_MOBILE,
  RESEND_VERIFY_EMAIL
} from '../../constants';
import { api } from '../api';

export const profileSlice = api.injectEndpoints({
  endpoints: (build) => ({
    resendVerifyMobile: build.query<void, void>({
      query: () => `${RESEND_VERIFY_MOBILE}`
    }),
    resendVerifyEmail: build.query<void, void>({
      query: () => `${RESEND_VERIFY_EMAIL}`
    }),
    initMobile: build.mutation<void, { mobile: string }>({
      query(data) {
        return {
          url: INIT_MOBILE,
          method: 'POST',
          body: data
        };
      }
    }),
    initEmail: build.mutation<void, { email: string }>({
      query(data) {
        return {
          url: INIT_EMAIL,
          method: 'POST',
          body: data
        };
      }
    }),
    verifyMobile: build.mutation<void, { code: string }>({
      query(data) {
        return {
          url: VERIFY_MOBILE,
          method: 'POST',
          body: data
        };
      }
    }),
    verifyEmail: build.mutation<void, { code: string }>({
      query(data) {
        return {
          url: VERIFY_EMAIL,
          method: 'POST',
          body: data
        };
      }
    })
  }),

  overrideExisting: false
});

export const {
  useInitEmailMutation,
  useInitMobileMutation,
  useLazyResendVerifyEmailQuery,
  useLazyResendVerifyMobileQuery,
  useVerifyEmailMutation,
  useVerifyMobileMutation
} = profileSlice;
